module.exports = __webpack_public_path__ + "static/media/earth.77d5c8d5.png";